import { combineReducers } from "@reduxjs/toolkit";
import {
  checkEnrollmentReducer,
  enrollReducer,
  getTotalEnrollInstructorReducer,
  myTotalEnrollmentReducer,
} from "./slices";

const enrollmentReducer = combineReducers({
  checkEnrollment: checkEnrollmentReducer,
  enroll: enrollReducer,
  myTotalEnrollment: myTotalEnrollmentReducer,
  getTotalEnrollInstructor: getTotalEnrollInstructorReducer,
});

export default enrollmentReducer;
